<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card" id="orderList">
                    <div class="card-header border-0">
                        <div class="d-flex align-items-center">
                            <h5 class="card-title mb-0 flex-grow-1">تاریخچه سفارش‌ها</h5>
                        </div>
                    </div>
                    <div class="card-body border border-dashed border-end-0 border-start-0">
                        <form class="orders-list-filter-area">
                            <div class="row g-3">
                                <div class="col-xxl-2 col-sm-6 filter-param">
                                    <div class="filter-title">
                                        از تاریخ
                                    </div>
                                    <date-picker v-model="fromDate"></date-picker>
                                </div>
                                <!--end col-->
                                <div class="col-xxl-2 col-sm-6 filter-param">
                                    <div class="filter-title">
                                        تا تاریخ
                                    </div>
                                    <date-picker v-model="toDate"></date-picker>
                                </div>
                                <!--end col-->
                                <div class="col-xxl-1 col-sm-4 filter-submit">
                                    <div>
                                        <button type="button" class="btn btn-primary w-100" @click="SearchData">
                                            <i class="ri-equalizer-fill me-1 align-bottom"></i>
                                            فیلتر
                                        </button>
                                    </div>
                                </div>
                                <!--end col-->
                            </div>
                            <!--end row-->
                        </form>
                    </div>
                    <div class="card-body pt-0">
                        <div>

                            <statusesTab v-if="!isStatusLoading" :statuses="orderStatuses" />
                            <statusesTabSkeleton v-else />

                            <orderList v-if="!isOrderLoading" :orders="orders" />
                            <orderListSkeleton v-else />

                            <div class="d-flex justify-content-end mt-3">
                                <div class="pagination-wrap hstack gap-2">
                                    <a
                                        class="page-item pagination-prev disabled"
                                        href="#"
                                        v-if="page != 1"
                                        @click="page--;  fetchPromises()"
                                    >
                                        قبلی
                                    </a>
                                    <ul class="pagination listjs-pagination mb-0">
                                        <li
                                            v-for="(pageNumber, index) in pages.slice(
                        page - 1,
                        page + 5
                      )"
                                            :key="index"
                                            @click="page = pageNumber;  fetchPromises()"
                                            :class="{
                              active: pageNumber == page,
                              disabled: pageNumber == '...',
                            }"
                                        >
                                            <a class="page" href="#">{{ pageNumber }}</a>
                                        </li>
                                    </ul>
                                    <a class="page-item pagination-next" href="#" @click="page++; fetchPromises()" v-if="page < pages.length">
                                        بعدی
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </Layout>
</template>
<script>
import DatePicker from 'vue3-persian-datetime-picker'

import statusesTab from "./order/statuses-tab";
import statusesTabSkeleton from "./order/statuses-tab-skeleton";
import orderList from "./order/order-list";
import orderListSkeleton from "./order/order-list-skeleton";

import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import UserService from "@/services/user.service";
export default {
    page: {
        title: "سفارش‌ها",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "سفارش‌ها",
            page: 1,
            perPage: 10,
            pages: [],
            fromDate: null,
            toDate: null,
            orders: [],
            ordersCount: '',
            orderStatuses: [],
            isStatusLoading: true,
            isOrderLoading: true,
        };
    },
    components: {
        Layout,
        PageHeader,
        DatePicker,
        statusesTab,
        statusesTabSkeleton,
        orderList,
        orderListSkeleton
    },
    computed: {
    },
    watch: {
        orders() {
            this.setPages();
        },
        // resultQuery(newValue) {
        //   return newValue;
        // },
    },
    created() {
        this.fetchPromises();
        this.setPages();
    },
    filters: {
        trimWords(value) {
            return value.split(" ").splice(0, 20).join(" ") + "...";
        },
    },
    methods: {
        fetchOrders() {
            return UserService.getBranchOrders({'per_page': this.perPage, 'paged': this.page})
                .then((response) => {
                    const {data} = response;
                    const {orders, total} = data;
                    console.log(orders);
                    this.orders = orders;
                    this.ordersCount = total;
                    this.isOrderLoading = false;
                });
        },
        fetchPromises() {
            this.isOrderLoading = true;
            Promise.all([
                this.fetchOrders(),
            ])
        },
        setPages() {
            this.pages = [];
            let numberOfPages = Math.ceil(this.ordersCount / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },
        paginate(orders) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;
            return orders.slice(from, to);
        },
        SearchData() {
            this.resultQuery;
            // var isstatus = document.getElementById("idStatus").value;
            //   var payment = document.getElementById("idPayment").value;
        },
    },
};
</script>
